import React, { useEffect, useRef, useState } from "react";

import {
  MDBBreadcrumb,
  MDBBreadcrumbItem, MDBBtn, MDBDatatable, MDBIcon,
  MDBSpinner,
  MDBTabs, MDBTabsContent, MDBTabsItem,
  MDBTabsLink, MDBTabsPane
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { getSpecificHuntGroup } from "../apiclients/streamsapi_bridge";



import { Tooltip } from "react-tooltip";
import Body from '../components/body/BodyPage';
import HGSettings from "../components/editviews/hunt/HGSettings";
import UsersAndPhonNumbers from "../components/editviews/hunt/UsersAndPhnums";
import MainLinks from '../components/navlinks/MainLinks';
import HuntSupervisors from "../components/editviews/hunt/HuntSupervisors";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";


export default function HuntGroupDetails(props) {
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const containerRef = useRef(null);



  const location = useLocation();
  const [basicActive, setBasicActive] = useState("tab1");



  const [basicModal1, setBasicModal1] = useState(false);

  const toggleShow1 = () => setBasicModal1(!basicModal1);
  const [selectVal, setSelectVal] = useState("africa");
  const [verticalActive, setVerticalActive] = useState("tab1");
  const [hgextension, setHGExtension] = useState('');
  const ref = useRef(null);
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [isSequentialGroup, setIsSequentialGroup] = useState(0);
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [reqFromCallFlow, setreqFromCallFlow] = useState(false);

  function closeSave(e) {
    navigate("/huntgroup");
  }





  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    } else if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }
    setBasicActive(value);
  };

  useEffect(() =>{
    const huntCode = localStorage.getItem("huntGrpInfo");
    // alert(JSON.parse(huntCode))
    if (huntCode) {
      setreqFromCallFlow(true);
      setHuntGInfo({ code: JSON.parse(huntCode) });
      localStorage.removeItem("huntGrpInfo");
    }

  }, [])
  const handleOk = () => {
    setEdited(false);
    if (targetView.indexOf("/") !== -1) {
      navigate(targetView);
    } else {
      setBasicActive(targetView);
    }
    setShowWarning(false);
  };

  const defaultData1 = [
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
  ];
  const [contentData, setContentData] = useState(defaultData1);

  //Hunt group related groups.

  const [asyncData, setAsyncData] = useState([]);

  const defaultData = [
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
  ];
  const onContentSearch = (value) =>
    setContentData(
      defaultData.filter((item) =>
        item.toLowerCase().startsWith(value.toLowerCase())
      )
    );

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  const [hgcode, sethgcode] = useState('');
  const [hgtitle, setHGTitle] = useState('');
  const [hgInfoObj, setHGInfoObj] = useState();
  const [reRender, setReRender] = useState(false);
  const [assocCallFlows, setAssocCallFlows] = useState([]);
  const [huntGInfo, setHuntGInfo] = useState(
    location.state ? location.state : {}
  );
  const [executeSetting, setExecuteSettings] = useState(false);
  console.log("1111111111111111111111");
  console.log(huntGInfo)

  // Fetches the specific group information.
  async function getSpecificHG() {
    try {
      setIsloading(true);
      const response = await getSpecificHuntGroup(JSON.parse(sessionStorage.getItem("admin_session")).siteid, huntGInfo.code);
      setTimeout(() => { setIsloading(false) }, 1000);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      let rawData = await response.json();
      if (!rawData) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      setHGInfoObj({ ...rawData, code: huntGInfo.code });
      setHuntGInfo(rawData);
      sethgcode(huntGInfo.code);
      setHGTitle(huntGInfo.title ?? huntGInfo.groupName);
      setHGExtension(huntGInfo.extensions ?? huntGInfo.extension);
      setReRender(false);
      setExecuteSettings(true);
      setAssocCallFlows(rawData.associated_callflows);
    } catch (e) {
      console.log(`Unable to load the sepcific group info:${e}`);
    }
  }

  // function convertToggleData(HGInfoObj){
  //   if(HGInfoObj.supervisorpart?.length > 0){
  //     let supervisor = HGInfoObj.supervisorpart;
  //     supervisor.forEach((element) => {
  //       element.callmonitor = element.callmonitor == 1 ? true : false;
  //       element.recording = element.callmonitor  == 1 ? true : false;
  //       element.privilage = +(element.privilage?? 0)
  //     });
  //   }
  //   if(HGInfoObj.supervisornotpart?.length > 0){
  //     let supervisorNotPart = HGInfoObj.supervisornotpart;
  //     supervisorNotPart.forEach((element) => {
  //       element.callmonitor = element.callmonitor == 1 ? true : false;
  //       element.recording = element.callmonitor  == 1 ? true : false;
  //       element.privilage = +(element.privilage?? 0)
  //     });
  //   }
  //   return HGInfoObj;
  // }


  useEffect(() => {
    if ((huntGInfo.code || reRender) && !(basicActive != "tab1") ) {
      getSpecificHG();
    }
  }, [huntGInfo.code, reRender,basicActive]);

  return (
    <React.Fragment>
      <>

        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={19}
          content={
            <section>
              <div className="card card-height">
                <div className="card-header py-3 px-0">
                  <h5 className="mb-0 ">
                    <MDBBreadcrumb>
                      <MDBBreadcrumbItem>
                        <a
                          onClick={(e) => {
                            if (isEdited) {
                              setTargetView("/huntgroup");
                              setShowWarning(true);
                              return;
                            }
                            navigate("/huntgroup");
                          }}
                        >
                          <strong>{t("phoneSystem")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem active>
                        <a
                          onClick={(e) => {
                            if (isEdited) {
                              setTargetView("/huntgroup");
                              setShowWarning(true);
                              return;
                            }
                            navigate("/huntgroup");
                          }}>
                          <strong>{t("huntGroups")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem>
                        <a href="">
                          <strong>{hgInfoObj?.groupName}</strong>
                        </a>
                      </MDBBreadcrumbItem>

                    </MDBBreadcrumb>
                  </h5>
                </div>
                <div className="card-body px-0">

                  <div className="pb-2">
                    <h5 className="fw-600 mt-2 ">
                      {hgInfoObj?.groupName}
                    </h5>
                    <p className="mt-2 text-secondary">
                      Extension: {hgInfoObj?.extension}
                    </p>
                    {assocCallFlows && assocCallFlows?.length > 0 && (
                      <h6 className="mt-2">
                        <strong className="mt-3 mb-0">Associated Call Flow</strong>
                        <p className="mt-2">
                          {assocCallFlows?.map(obj => (' ' + obj.name + ' : ' + obj.extension + ' ')).toString()}
                        </p>
                      </h6>
                    )}
                  </div>
                  <MDBTabs>
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab1")}
                        active={basicActive === "tab1"}
                      >
                        {t("settings")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab2")}
                        active={basicActive === "tab2"}
                      >
                        {t("users_Phone_Numbers")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab3")}
                        active={basicActive === "tab3"}
                      >
                        {t("supervisors")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                  </MDBTabs>
                  <MDBTabsContent className="vtabHeightHuntNew">

                    {basicActive === "tab1" &&
                      <MDBTabsPane open={basicActive === "tab1"} className="vtabHeightHuntNewHeight">
                        {/* Tab 1 */}
                        <HGSettings
                          hgGeneralInfo={hgInfoObj}
                          executeSetting={executeSetting}
                          setExecuteSettings={setExecuteSettings}
                          setReRender={setReRender}
                          setIsloading={setIsloading}
                          assocCallFlows={assocCallFlows}
                          setIsSequentialGroup={setIsSequentialGroup}
                          setEdited={setEdited}
                          setreqFromCallFlow={setreqFromCallFlow}
                          reqFromCallFlow={reqFromCallFlow}
                        />
                      </MDBTabsPane>
                    }

                    {basicActive === "tab2" &&
                      <MDBTabsPane open={basicActive === "tab2"} className="p-1">
                        {/* Tab 2 */}
                        <UsersAndPhonNumbers
                          hgcode={huntGInfo.code}
                          isSequentialGroup={isSequentialGroup}
                          isActive={basicActive === "tab2"}
                          setEdited={setEdited}
                        // setReRender={setReRender}

                        />
                      </MDBTabsPane>
                    }

                    <MDBTabsPane open={basicActive === "tab3"}>
                      <HuntSupervisors
                        code={huntGInfo.code}
                        isActive={basicActive === "tab3"}
                        isEdited={isEdited}
                        setEdited={setEdited}
                      />
                    </MDBTabsPane>
                  </MDBTabsContent>
                </div>
              </div>
              {isloading && (
                <>
                  <div className="loadingclass">
                    <MDBBtn disabled>
                      <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                      Loading...
                    </MDBBtn>
                  </div>
                </>
              )}
            </section>
          }
        />
        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          Remove
        </Tooltip>
        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}
      </>
    </React.Fragment >
  )
}
